
    var riot = require('riot')
    //src: starling/src/tags/menu/buttons/menu-button-select-all-in-region.html
riot.tag2('menu-button-select-all-in-region',
  '<svg class="bulk-actions-menu-item_icon"> <use xlink:href="#select-all-icon"></use> </svg>',
  '',
  'class="bulk-actions-menu-item" data-tip="Select all in region" onclick="{selectAllInRegion}"', function(opts) {
'use strict';

var _regionUi = require('lib/region-ui');

var _selectionUi = require('lib/selection-ui');

var canvas = opts.canvas;

this.selectAllInRegion = function () {
  for (var _iterator = _regionUi.regionUI.getSelectedRegionIds(), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var regionId = _ref;

    var regionTag = canvas.regionTags[regionId];
    if (!regionTag) return [];
    _selectionUi.selectionUI.selectAllInsideBox(regionTag.instance, true);
  }
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('menu-button-select-all-in-region')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/menu/buttons/menu-button-select-all-in-region.html
// module id = 759
// module chunks = 0